import { getModule, Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import store from "@/store";
import auth from "@/store/modules/auth";
import { FirestoreActionContext, FirestoreAction } from './vuexFirestoreHelper';
import { db } from "@/main"; 
import { TripEntity, FeedMessageEntity, FeedItemType } from '@/api/types';

interface Message {
  message: string,
  replyTo: string
}

@Module({
  namespaced: true,
  name: "trip",
  dynamic: true,
  store
})
class TripModule extends VuexModule {

  tripId: string | null = null;
  trip: TripEntity | null = null;
  
  feed: any[] = [];
  matches: any[] = [];

  @Mutation
  setTripId(id: string) {
    this.tripId = id;
  }

  @Action
  @FirestoreAction()
  bindTrip(id: string) {
    this.context.commit("setTripId", id);
    if (auth.user) {
      const { bindFirestoreRef } = this.context as FirestoreActionContext<any, any>;
      let tripRef = bindFirestoreRef("trip", db.collection("trips").doc(id));
      let feedRef = bindFirestoreRef("feed", db.collection("feed").where("to", "array-contains", id).orderBy("timestamp", "desc"));
      let matchesRef = bindFirestoreRef("matches", db.collection("trips").doc(id).collection("matches"));
      return Promise.all([tripRef, feedRef, matchesRef]);
    }
  }

  @Action
  sendFeedMessage(message: Message) {
    if (auth.user && this.tripId) {
      
      const user = auth.user;
      const feedMessage: FeedMessageEntity = {
        itemType: "message",
        message: message.message,
        to: this.matches.map(match => match.id),
        from: this.tripId,
        lastReply: null,
        user: {
          displayName: user.displayName,
          photoURL: user.photoURL,
          userId: user.uid
        },
        timestamp: Date.now()
      };
      //TODO: Add to its own collection with an array containing all matches (maybe in the backend) - we can then filter with array-contains and 
      //do not need to distribute the messages across feed subcollecitons. This makes it easier to implement responses (even with nested levels)
  
      if (message.replyTo != "") {
        return db.collection("feed").doc(message.replyTo).collection("replies").add(feedMessage);
      } else {
        return db.collection("feed").add(feedMessage);
      }
      //return db.collection("trips").doc(this.tripId).collection("sent").add(feedMessage);
    }
  }
}

export default getModule(TripModule);